module.exports = __webpack_public_path__ + "img/63.1d27322b.jpg";